import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import About from "./Component/About";
import Accessibility from "./Component/Accessibility";
import CartPage from "./Component/CartPage";
import { CartProvider } from "./Component/CartContext";
import CheckOut from "./Component/CheckOut";
import Contact from "./Component/Contact";
import Cookies from "./Component/Cookies";
import Delivery from "./Component/Delivery";
import Footer from "./Component/Footer";
import Faqs from "./Component/Faqs";
import Header from "./Component/Header";
import Main from "./Component/Main";
import MaterialsCare from "./Component/MaterialsCare";
import NotFound from "./Component/NotFound";
import PaymentSecurity from "./Component/PaymentSecurity";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import Returns from "./Component/Returns";
import Shop from "./Component/Shop";
import SizeGuide from "./Component/SizeGuide";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import siteConfig from "./config/siteConfig";
import "./App.css";

const staticTitles = {
  "/": `${siteConfig.brandName} | ${siteConfig.tagline}`,
  "/shop": `New arrivals | ${siteConfig.brandName}`,
  "/cartpage": `Shopping bag | ${siteConfig.brandName}`,
  "/checkout": `Checkout | ${siteConfig.brandName}`,
  "/paysuccess": `Order received | ${siteConfig.brandName}`,
  "/about": `Our story | ${siteConfig.brandName}`,
  "/contact": `Contact | ${siteConfig.brandName}`,
  "/shipping": `Delivery | ${siteConfig.brandName}`,
  "/returns": `Returns | ${siteConfig.brandName}`,
  "/privacy": `Privacy | ${siteConfig.brandName}`,
  "/cookies": `Cookie policy | ${siteConfig.brandName}`,
  "/faqs": `FAQs | ${siteConfig.brandName}`,
  "/terms": `General conditions | ${siteConfig.brandName}`,
  "/size-guide": `Size guide | ${siteConfig.brandName}`,
  "/payment-security": `Payment & security | ${siteConfig.brandName}`,
  "/materials-care": `Materials & care | ${siteConfig.brandName}`,
  "/accessibility": `Accessibility | ${siteConfig.brandName}`,
};

function AppLayout() {
  const location = useLocation();
  const isStandaloneCheckout = location.pathname === "/checkout";

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    if (staticTitles[location.pathname]) document.title = staticTitles[location.pathname];
  }, [location.pathname]);

  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      {!isStandaloneCheckout && <Header />}
      <div id="main-content" tabIndex="-1">
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/size-guide" element={<SizeGuide />} />
          <Route path="/payment-security" element={<PaymentSecurity />} />
          <Route path="/materials-care" element={<MaterialsCare />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isStandaloneCheckout && <Footer />}
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <AppLayout />
      </Router>
    </CartProvider>
  );
}

export default App;
